import React from 'react';
import './ThemeDisplay.css';

function ThemeDisplay({ theme, isDarkMode, date }) {
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  // Ensure YYYY-MM-DD is parsed as UTC midnight to prevent day-shift in local timezones
  const adjustedDate = new Date(date + 'T00:00:00Z');
  const formattedDate = adjustedDate.toLocaleDateString('en-US', {
    ...options,
    timeZone: 'UTC'
  });

  return (
    <div className={`theme-container ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className={`theme-header ${isDarkMode ? 'dark-mode' : ''}`}>THEME OF THE DAY | {formattedDate}</div>
      <div className={`theme-content ${isDarkMode ? 'dark-mode' : ''}`}>{theme}</div>
    </div>
  );
}

export default ThemeDisplay;
